import _objectWithoutProperties from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _applyDecoratedDescriptor from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _excluded = ["id", "price", "product_type", "amount"];

var _dec, _class;

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import Protocol from './protocol';
import { invoke } from './lib/tenvideo';
import { assign } from './util';
import { version } from './util/decorators';
var CODE_PURCHASE_CANCEL = 12;
var CODE_PURCHASE_UNKNOWN = -1;
/**
 * 小企鹅 JSBridge
 * @class WetvJSBridge
 * @extends {Phone}
 */

var KidJSBridge = (_dec = version('5.7.0'), (_class = /*#__PURE__*/function (_Protocol) {
  _inherits(KidJSBridge, _Protocol);

  var _super = _createSuper(KidJSBridge);

  function KidJSBridge() {
    var _this;

    _classCallCheck(this, KidJSBridge);

    _this = _super.call(this);
    _this.name = 'KidJSBridge';
    return _this;
  }

  _createClass(KidJSBridge, [{
    key: "logout",
    value: function logout() {
      return invoke('logout', {
        needBack: false
      });
    }
  }, {
    key: "checkDiscount",
    value: function checkDiscount() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(KidJSBridge.prototype), "checkDiscount", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "openPay",
    value: function openPay() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var id = options.id,
          price = options.price,
          product_type = options.product_type,
          amount = options.amount,
          params = _objectWithoutProperties(options, _excluded);

      if (!id) {
        throw {
          errCode: -10,
          errMsg: '[atom.openPay]miss required option(options.id)'
        };
      }

      assign(params, {
        product_price: price,
        productprice: price,
        id: id,
        productid: id,
        product_type: 'month',
        month: amount
      }); // eslint-disable-next-line

      if (product_type === 'serial') {
        params.serialpay = 1;
      }

      invoke('openPay', params);
      return new Promise(function (resolve, reject) {
        _this2.once('PurchaseStatusCallback', function (data) {
          var state = data && data.result && data.result.state ? data.result.state : '';
          console.log('kid:openPay:PurchaseStatusCallback', state, data);

          switch (state) {
            case 'PurchaseSuccess':
              resolve({
                paySucc: 1,
                payStatus: 1
              });
              break;

            case 'PurchaseCancel':
              reject({
                paySucc: 0,
                payStatus: CODE_PURCHASE_CANCEL
              });
              break;

            default:
              // PurchaseFailed或其他回调
              reject({
                paySucc: 0,
                payStatus: CODE_PURCHASE_UNKNOWN
              });
              break;
          }
        });
      });
    }
    /**
     * 全局推消息
     */

  }, {
    key: "postMessage",
    value: function postMessage() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.invoke('publishMsgToAllWebView', {
        messageName: event,
        messageParams: params
      });
    }
  }]);

  return KidJSBridge;
}(Protocol), (_applyDecoratedDescriptor(_class.prototype, "checkDiscount", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "checkDiscount"), _class.prototype)), _class));
export default new KidJSBridge();